export default __webpack_public_path__ + "static/media/header.e148c550.png";